


const userContext = {user: JSON.parse(localStorage.getItem('user'))};
const clubContext = {clubs: JSON.parse(localStorage.getItem('clubs'))};

export {userContext, clubContext};
